<template>
  <router-view></router-view>  
</template>
<script>
export default {
	name: 'organizational',
};
</script>




// WEBPACK FOOTER //
// src/pages/organizational/page-organizational.vue